<template>
	<div
		class="header"
		:style="{
			height: height + 'px',
			'background-image':
				setHeaderBackgroundImg == 'none'
					? 'none'
					: 'url(' + setHeaderBackgroundImg + ')',
		}"
		style="
			background-repeat: no-repeat;
			background-size: cover;
			background-position: center center;
		"
	>
		<!-- <div
      class="header-content"
      ref="headerContent"
      :style="{
        'background-image':
          setHeaderContentBackgroundImg == 'none'
            ? 'none'
            : 'url(' + setHeaderContentBackgroundImg + ')',
        width: contentWidth + 'px',
      }"
    > -->
		<div
			class="header-content"
			ref="headerContent"
			:style="{
				'background-image':
					setHeaderContentBackgroundImg == 'none'
						? 'none'
						: 'url(' + setHeaderContentBackgroundImg + ')',
				width: contentWidth + 'px',
			}"
		>
			<!-- 顶部导航插槽（放登录/忘记密码/注册等链接） -->
			<div class="header-nav">
				<slot name="topBannerNav"></slot>
			</div>
			<div
				class="header-logo"
				:style="styleApi + ':' + setLogoMargin + 'px;'"
				ref="headerLogo"
			>
				<img class="logo-img" src="./images/TopBannerLogo.png" alt="" />
				<a
					class="version-name"
					href=""
					:style="
						'vertical-align: ' +
						versionNameVerticalAlign +
						'px;color:' +
						versionNameColor +
						';font-size:' +
						versionNameFontSize +
						'px;'
					"
					v-if="versionNameShow == 1"
					>{{ this.versionName }}
					<slot name="subtitle"></slot>
				</a>
			</div>
			<slot name="topBannerContent"></slot>
		</div>
	</div>
</template>

<script>
import '@/assets/css/base.css';
export default {
	name: 'TopBanner',
	props: {
		// 整体headerBanner容器高度
		height: String,
		// 版本名称
		versionName: String,
		// 版本名称垂直位置
		versionNameVerticalAlign: String,
		// 版本名称显示：1为显示
		versionNameShow: String,
		// 版本名称颜色
		versionNameColor: String,
		// 版本名称字体大小
		versionNameFontSize: String,
		// padding-top || padding-bottom || padding-left
		styleApi: String,
		// logo高度
		logoMargin: String,
		// header背景图
		headerBackgroundImg: String,
		// 主体内容背景图
		headerContentBackgroundImg: String,
		// content Width
		contentWidth: String,
	},
	data() {
		return {
			setLogoMargin: '',
			// header背景图
			setHeaderBackgroundImg: '',
			// 主体内容背景图
			setHeaderContentBackgroundImg: '',
		};
	},
	mounted() {
		// logo：margin-top DATA
		this.setLogoMargin =
			this.logoMargin == '0'
				? (this.height - this.$refs.headerLogo.offsetHeight) / 2
				: this.logoMargin;
		// header背景图（防止 prop 未传导致 require('./images/undefined') 报错）
		if (this.headerBackgroundImg && this.headerBackgroundImg != 'none') {
			this.setHeaderBackgroundImg = require('./images/' +
				this.headerBackgroundImg);
		} else {
			this.setHeaderBackgroundImg = 'none';
		}
		// 主体内容背景图（同上保护）
		if (
			this.headerContentBackgroundImg &&
			this.headerContentBackgroundImg != 'none'
		) {
			this.setHeaderContentBackgroundImg = require('./images/' +
				this.headerContentBackgroundImg);
		} else {
			this.setHeaderContentBackgroundImg = 'none';
		}
	},
};
</script>

<style lang="less" scoped>
.header {
	width: 100%;

	// background-image: url(./images/HeaderBackgroundImg.png);
	.header-content {
		position: relative;
		width: 1400px;
		margin: 0 auto;
		background-size: cover;
		// padding: 22px 0;

		// 顶部右对齐的导航插槽（登录/忘记密码/注册等）
		.header-nav {
			position: absolute;
			top: 8px;
			right: 0;
			z-index: 2;
			font-size: 13px;
		}

		.header-logo {
			display: inline-block;
			font-family: '微软雅黑';
			padding-left: 110px;
			.version-name {
				font-size: 22px;
				font-weight: bold;
				color: rgb(39, 131, 210);
				margin-left: 16px;
			}
		}
	}
}
.logo-img {
	width: 418px;
}
@media (max-width: 769px) {
	.header-content,
	.header-content {
		width: 100% !important;
	}
	.header {
		height: 161px !important;
		background-size: cover !important;
	}

	// 移动端 logo + 版本名 上下排
	.header-logo {
		padding-top: 40px !important;
		display: flex !important;
		flex-direction: column;
		align-items: center;
		gap: 6px;
	}

	.header-logo img {
		height: 55px;
		width: auto;
	}

	.header-logo .version-name {
		font-size: 16px !important;
		margin-left: 0 !important;
	}

	// 移动端隐藏顶部导航链接
	.header-nav {
		display: none;
	}
}

// 平板（769~1450px）：logo 缩小但仍一行
@media (max-width: 769px) {
	.header-content {
		width: calc(100% - 30px) !important;
	}
	.header-logo {
		padding-top: 50px !important;
	}
	.header-logo img {
		height: 50px;
	}
	.header-logo .version-name {
		font-size: 18px !important;
	}
	// .logo-img {
	// 	width: 500px;
	// }
}
</style>
